module.exports = __webpack_public_path__ + "img/leaf-moisture.283bb6fb.svg";